exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block[data-v-2611fd3a]{border-radius:3px;margin-bottom:10px}.block-active[data-v-2611fd3a]{background-image:linear-gradient(17deg,rgba(243,248,255,.03) 63.45%,rgba(207,214,229,.4) 98%)}.block .block-slot[data-v-2611fd3a]{outline:1px dashed #dcdfe6;position:relative;padding:16px 8px 8px}.block .block-slot:hover>.block-label[data-v-2611fd3a]{display:block}.block .block-label[data-v-2611fd3a]{position:absolute;left:0;top:0;color:#fff;cursor:pointer;background:#bdc0c7;padding:0 6px;font-size:10px;line-height:16px;z-index:10;display:none}.block .block-label.block-label-active[data-v-2611fd3a]{background:#409eff}.block-active .block-label[data-v-2611fd3a]{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-2611fd3a","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/box/box.vue
// module id = 71
// module chunks = 0